import Button from "@app/sharedComponents/Button/Button"
import InputText from "@app/sharedComponents/TextInput/TextInput"
import { ThemedText, ThemedView } from "@app/theme"
import FoldedHands from '../../../assets/Icons/FoldedHands'
import { useState } from "react"
import { Platform } from "react-native"

const PoorExperience = ({id,buttonFn,setUserFeedback,userFeedback}) =>{
    const [showFeedback, setShowFeedback] = useState(true)
    return(
        <>
        {
        showFeedback ?
        <ThemedView p="lg" backgroundColor="bg-fill-primary" >
            <ThemedText variant="h3s" color="text-primary" >{id==5 ? 'Help us improve':'Other'}</ThemedText>
            <InputText 
                placeHolder="What was the reason you decided to close your account?" 
                showLabel={false} 
                multiline={true} 
                numberOfLines={5} 
                maxLength={500}
                value={userFeedback}
                onChangeText={setUserFeedback} 
                overRideContainerStyles={{marginVertical:16}}
                overRideInputStyles={{height: 80 }}
                />
            <Button label="Submit" size="MD" handlePress={()=>{setShowFeedback(false)}}/>
        </ThemedView>:
        <ThemedView p="lg" backgroundColor="bg-fill-primary" >
            <FoldedHands/>
            <ThemedText variant="h3s" color="text-primary" my="lg">Thank you for your response</ThemedText>
            <ThemedText variant="b3r" color="text-primary" mb="lg">We appreciate your input and will use it to enhance your experience with us.</ThemedText>
            <Button label="Proceed to close account" size="MD" handlePress={buttonFn?.btnFn}/>
        </ThemedView>
        }
        {Platform.OS === 'android' && <ThemedView height={50} />}

        </>
    )
}

export default PoorExperience